var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"hint-sign",class:{
    'hint-sign--hovered': _vm.hovered,
  }},_vm.$listeners),[_c('svg',{attrs:{"width":_vm.frameSize,"height":_vm.frameSize}},[_c('circle',{staticClass:"hint-sign__bar",class:{
        'hint-sign__bar--open': _vm.isOpen,
      },style:(_vm.barStyle),attrs:{"stroke-width":_vm.strokeWidth,"r":_vm.radiusConsideringStrokeWidth,"cx":_vm.radius,"cy":_vm.radius}}),_vm._v(" "),_c('text',{staticClass:"hint-sign__question-mark",attrs:{"x":_vm.radius,"y":_vm.radius * 1.5,"text-anchor":"middle"}},[_vm._v("\n      ?\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }